<template>
  <div class="w-full w-max-[600px] mx-auto flex justify-center items-start">
    <div class="flex flex-col items-center justify-center w-full mt-[15%]">
      <div class="z-20">
        <div class="flex items-center justify-start">
          <img v-if="profile.pictureUrl !== ''" :src="profile.pictureUrl" class="w-[43px] ml-2 rounded-full">
          <img v-else src="../assets/images/icon_user.png" class="w-[43px] ml-2">
          <p class="ml-2 text-white text-xl font-bold">{{profile.displayName}}</p>
        </div>
        <div class="flex items-center justify-between mt-4 input-frame py-2 pl-5 text-[#707070] bg-[#f6f6f6c1] w-[100%]">
          <p class="text-xl w-1/4">i點數</p>
          <p type="text" class="text-xl w-4/5 text-right pr-5" v-if="decryptedData">{{points}}</p>
        </div>
        <p class="text-xs text-white mt-2">分享越多企業好友完成填寫獲越多點數，點數可兌換好禮!</p>
        <p class="text-lg font-bold text-[#d2c535] mt-5" @click="goto('/exchange')">> 兌換優惠券</p>
        <p class="text-lg font-bold text-[#d2c535] mt-2" @click="goto('/')">> 兌換抽獎券</p>
      </div>
      <img src="../assets/images/ai_bg_4.png" class="absolute top-0 left-0 w-full scale-110" alt="">
      <img src="../assets/images/ai_bg_money_2.png" class="ai-bg-money w-full scale-110" alt="">
      <img src="../assets/images/ai_title_3.png"  class="z-10 w-[95%] absolute top-[443px]">
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import axios from 'axios'
export default {
  name: 'PointView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      point: 0,
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: ''
      },
      key: '5334023153340231',
      decryptedData: null,
      points: 0
    }
  },
  created () {
    this.profile.userId = localStorage.getItem('userId') || ''
    this.profile.displayName = localStorage.getItem('displayName') || ''
    this.profile.pictureUrl = localStorage.getItem('pictureUrl')
  },
  async mounted () {
    this.getInf()
  },
  computed: {
  },
  methods: {
    goto (route) {
      this.$router.push(route)
    },
    async getInf () {
      console.log('222')
      await axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/LineInfo?lineid=${this.profile.userId}`
      }).then((response) => {
        this.inf = response.data
        this.decryptData(this.inf)
        if (this.decryptedData) {
          console.log('224', this.decryptedData)
          if (this.decryptedData.code === '100' && this.decryptedData.openId !== '') {
            this.points = this.decryptedData.points
          } else {
            this.$router.replace({ name: 'bind', query: { source: 'wallet' } })
          }
        }
      })
    },
    // 解密
    decryptData (data) {
      try {
        const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
        const encryptedWordArray = CryptoJS.enc.Base64.parse(data)
        // 使用 AES-128-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: encryptedWordArray },
          keyWordArray,
          { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        )
        this.decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
      } catch (error) {
        this.decryptedData = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.point{
  min-height: 100vh;
  background-image: url('../assets/images/ai_bg_4.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: bottom;
}
.ai-bg-money {
  bottom: 5%;
  left: -20px;
  width: 100%;
  max-height: 100vh;
  object-fit: cover;
}
.input-frame{
  border: 1px solid #707070;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  input{
    outline: none;
    background: transparent;
  }
  ::placeholder {
    color: #292929;
  }
}
</style>
